<template>
  <div class="corpo">
    <div class="header">
      <div style="display: flex; align-items: center" class="medio">
        <unicom-icone
          :especuraDoIcone="1"
          nome="file"
          :tamanho="24"
          class="segunda-cor-fonte"
        />
        <span style="margin-left: 12px"> Arquivos </span>
      </div>
      <div style="margin-left: auto">
        <transition name="slide-botao" mode="out-in">
          <unicom-botao
            @click="$emit('baixar-todos')"
            contornado
            nomeIcone="download-cloud"
            :largura="220"
            v-if="checkbox.length === 0"
          >
            BAIXAR TUDO
          </unicom-botao>
          <unicom-botao
            @click="$emit('baixar-selecionados')"
            contornado
            nomeIcone="download-cloud"
            :largura="260"
            v-else
          >
            BAIXAR SELECIONADOS
          </unicom-botao>
        </transition>
      </div>
    </div>
    <div class="container-tabela-download scroll-design">
      <table class="tabela">
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>
              <unicom-checkbox
                :checked="checkbox"
                @input="v => $emit('input', v)"
                :value="row.id"
              />
            </td>
            <td>
              {{ row.nomeArquivo }}
            </td>
            <td class="segunda-cor-fonte">
              {{ row.data }}
            </td>
            <td>
              <DownloadCircular
                :key="row.id"
                :loading="loadings[row.id]"
                @baixar="$emit('baixar', row.id)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <unicom-paginacao-v3
      class="paginacao-download"
      :exibirBotaoPaginacao="exibirBotaoPaginacao"
      :mostrarBotaoUltimo="false"
      textoExibindo="resultados"
      :qtPaginaAtual="zeroEsquerda(rows.length, 2)"
      :qtTotal="zeroEsquerda(qtTotal, 2)"
      :qtPaginas="qtPaginas"
      :value="pagina"
      @input="p => $emit('trocar-pagina', p)"
    />
  </div>
</template>

<script>
import DownloadCircular from "./componentes/DownloadCircular";

export default {
  components: {
    DownloadCircular
  },
  props: {
    checkbox: {
      type: Array,
      default: () => []
    },
    loadings: {
      type: Array,
      default: () => []
    },
    qtTotal: {
      type: Number,
      default: 0
    },
    pagina: {
      type: Number,
      default: 0
    },
    qtPaginas: {
      type: Number,
      default: 0
    },
    rows: {
      type: Array,
      default: () => []
    },
    exibirBotaoPaginacao: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.corpo {
  min-width: 564px;

  .header {
    display: flex;
    align-items: flex-end;
    margin-bottom: 24px;
  }

  .container-tabela-download {
    overflow: auto;
    box-sizing: border-box;
    color: #60656c;
    height: 290px;

    & table {
      width: 100%;

      tr {
        height: 48px;

        &:nth-child(1) {
          border-top: 1px solid #ebebeb;
        }

        td {
          vertical-align: middle;
          display: table-cell;
          padding: 10px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #ebebeb;
          text-align: left;

          &:not(:nth-child(1)) {
            padding-left: 10px;
          }
        }
      }
    }
  }

  .paginacao-download {
    margin-top: auto !important;
    padding-top: 36px;
  }
}

.slide-botao-enter-active,
.slide-botao-leave-active {
  transition-duration: 0.15s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-botao-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-botao-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
